import { useEffect } from 'react';

import { createUpdateEffect } from '../createUpdateEffect';

export default createUpdateEffect(useEffect);
